import '../images/m1.jpg?1';
import '../images/m2.jpg?1';
import '../images/m3.jpg?1';
import '../images/m4.jpg?1';

import debounce from 'debounce';

let timer;

export default class ChangeBG {
    static of(triggers, container) {
        return new ChangeBG(triggers, container)
    }

    constructor(triggers, container) {
        this.triggers = triggers;
        this.container = container;

        this.img = $('<img />');
        this._img = $('img', container);

        this._prefetch();

        triggers.on('mouseenter', this._show.bind(this));
        triggers.on('mouseleave', this._hide.bind(this));
    }

    _prefetch() {

        let deferred = $.Deferred();
        const events = `load.waitImg error.waitImg`;

        this.triggers.map((i, trigger) => {
            const img = $('<img />');
            img.attr('src', `/media/images/m${trigger.dataset.changeTrigger}.jpg`).one(events, () => {
                deferred.resolve();
            });
        });
        return deferred.promise();
    }

    _show(e) {
        const id = e.currentTarget.dataset.changeTrigger;

        timer = setTimeout(() => {
            this.img.attr('src', `/media/images/m${id}.jpg`);

            this.container.append(this.img);
            this.img.animateCss('zoomIn', () => {
                this._img.attr('src', `/media/images/m${id}.jpg`);
            });
        }, 100);

    }

    _hide() {
        clearTimeout(timer);
        //this.img.animateCss('');
    }
}



// WEBPACK FOOTER //
// ./scripts/change-bg.js